// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('power_ups_card_aging_prefs');

// eslint-disable-next-line @trello/no-module-logic
export const PowerUpsCardAgingPrefsTemplate = t.renderable(function ({
  agingMode,
  canChange,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  t.h2(() => t.format('how-do-you-want-the-aged-cards-to-look'));

  return t.ul('.pop-over-list', function () {
    t.li(() =>
      t.a(
        '.js-select',
        {
          href: '#',
          class: t.classify({ disabled: !canChange }),
          name: 'regular',
        },
        function () {
          t.span('.name', () => t.format('regular-mode'));

          if (agingMode === 'regular') {
            t.icon('check');
          }

          return t.span('.sub-name', () =>
            t.format('older-cards-become-more-transparent'),
          );
        },
      ),
    );

    return t.li(() =>
      t.a(
        '.js-select',
        {
          href: '#',
          class: t.classify({ disabled: !canChange }),
          name: 'pirate',
        },
        function () {
          t.span('.name', () => t.format('pirate-mode'));

          if (agingMode === 'pirate') {
            t.icon('check');
          }

          return t.span('.sub-name', () =>
            t.format('older-cards-crackle-and-tear'),
          );
        },
      ),
    );
  });
});
